<template>
  <!-- <div class="echart01">
    </div> -->
  <div ref="echart01" style="width:100%; height:200px;"></div>
</template>

<script>
export default {
  props:{
    data04:{type: Array}
  },
  mounted() {
    let chart01 = this.$echarts.init(this.$refs.echart01)
    let color = ['#5396F2', '#16DCC7', '#F64D5B']

    // let xAxisData = ['2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015','2014','2013']
    // let xAxisData = ['2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015','2013','2012']
    //let xAxisData = this.data04.years;
    let xAxisData = this.data04.xData;
    // let tempSumList = this.data04.sumList[0];
    // this.data04.sumList =[];
    // this.data04.sumList.push(tempSumList.COUNT0);
    // this.data04.sumList.push(tempSumList.COUNT1);
    // this.data04.sumList.push(tempSumList.COUNT2);
    // this.data04.sumList.push(tempSumList.COUNT3);
    // this.data04.sumList.push(tempSumList.COUNT4);
    // this.data04.sumList.push(tempSumList.COUNT5);
    // this.data04.sumList.push(tempSumList.COUNT6);
    // this.data04.sumList.push(tempSumList.COUNT7);
    // this.data04.sumList.push(tempSumList.COUNT8);
    // this.data04.sumList.push(tempSumList.COUNT9);
    //
    //
    // let tempManList = this.data04.manList[0];
    // this.data04.manList =[];
    // this.data04.manList.push(tempManList.COUNT0);
    // this.data04.manList.push(tempManList.COUNT1);
    // this.data04.manList.push(tempManList.COUNT2);
    // this.data04.manList.push(tempManList.COUNT3);
    // this.data04.manList.push(tempManList.COUNT4);
    // this.data04.manList.push(tempManList.COUNT5);
    // this.data04.manList.push(tempManList.COUNT6);
    // this.data04.manList.push(tempManList.COUNT7);
    // this.data04.manList.push(tempManList.COUNT8);
    // this.data04.manList.push(tempManList.COUNT9);
    //
    // let tempWoManList = this.data04.woManList[0];
    // this.data04.woManList =[];
    // this.data04.woManList.push(tempWoManList.COUNT0);
    // this.data04.woManList.push(tempWoManList.COUNT1);
    // this.data04.woManList.push(tempWoManList.COUNT2);
    // this.data04.woManList.push(tempWoManList.COUNT3);
    // this.data04.woManList.push(tempWoManList.COUNT4);
    // this.data04.woManList.push(tempWoManList.COUNT5);
    // this.data04.woManList.push(tempWoManList.COUNT6);
    // this.data04.woManList.push(tempWoManList.COUNT7);
    // this.data04.woManList.push(tempWoManList.COUNT8);
    // this.data04.woManList.push(tempWoManList.COUNT9);

    let yAxisData1=[];
    // let yAxisData1 = [100, 38, 50, 73, 80, 50, 80, 30,30,30]
    let yAxisData2=this.data04.yData1
    let yAxisData3=this.data04.yData2
    // let yAxisData2 = [70, 20, 24, 50, 40, 45, 70, 18,30,30]
    // let yAxisData3 = [30, 18, 26, 13, 40, 5, 10, 12,30,30]

    function subtract(){
      let arr=[]
      yAxisData2.forEach((value, index)=>{
        arr.push(yAxisData2[index]+yAxisData3[index])
      })
      return arr;
    }
    yAxisData1=subtract();

    const hexToRgba = (hex, opacity) => {
      let rgbaColor = ''
      let reg = /^#[\da-f]{6}$/i
      if (reg.test(hex)) {
        rgbaColor = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt('0x' + hex.slice(3, 5))},${parseInt('0x' + hex.slice(5, 7))},${opacity})`
      }
      return rgbaColor
    }

    let option = {
      backgroundColor: '#fff',
      color: color,
      legend: {
        top: 0
      },
      tooltip: {
        trigger: 'axis',
        formatter: function(params) {
          let html = ''
          params.forEach(v => {
            html += `<div style="color: #666;font-size: 12px;line-height: 24px">
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color[v.componentIndex]};"></span>
                ${v.seriesName}${v.name}
                <span style="color:${color[v.componentIndex]};font-weight:700;font-size: 12px;margin-left:5px">${v.value}</span>人`
          })
          return html
        },
        extraCssText: 'background: #fff; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;',
        axisPointer: {
          type: 'shadow',
          shadowStyle: {
            color: '#ffffff',
            shadowColor: 'rgba(225,225,225,1)',
            shadowBlur: 5
          }
        }
      },
      grid: {
       top:'20%',
       left:'3%',
       right:'10%',
       bottom:'5%',
       containLabel:true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#333'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#D9D9D9'
            }
          },
          data: xAxisData
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '',
          axisLabel: {
            textStyle: {
              color: '#666'
            }
          },
          nameTextStyle: {
            color: '#666',
            fontSize: 12,
            lineHeight: 40
          },
          // 分割线
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#E9E9E9'
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        }
      ],
      series: [
        {
          // name: "2018",
          name: '总数',
          type: 'line',
          smooth: true,
          symbolSize: 8,
          zlevel: 3,
          itemStyle:{
            normal:{
              label : {
                show: true // 在折线拐点上显示数据
              }
            }
          },
          lineStyle: {
            normal: {
              color: color[0],
              shadowBlur: 3,
              shadowColor: hexToRgba(color[0], 0.5),
              shadowOffsetY: 8
            }
          },
          symbol: 'circle', //数0据交叉点样式
          areaStyle: {
            normal: {
              color: this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: hexToRgba(color[0], 0.3)
                  },
                  {
                    offset: 1,
                    color: hexToRgba(color[0], 0.1)
                  }
                ],
                false
              ),
              shadowColor: hexToRgba(color[0], 0.1),
              shadowBlur: 10
            }
          },
          data: yAxisData1
        },
        {
          name: '男',
          type: 'line',
          smooth: true,
          symbolSize: 8,
          zlevel: 3,
          itemStyle:{
            normal:{
              label : {
                show: true // 在折线拐点上显示数据
              }
            }
          },
          lineStyle: {
            normal: {
              color: color[1],
              shadowBlur: 3,
              shadowColor: hexToRgba(color[1], 0.5),
              shadowOffsetY: 8
            }
          },
          symbol: 'circle', //数据交叉点样式 (实心点)
          areaStyle: {
            normal: {
              color: this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: hexToRgba(color[1], 0.3)
                  },
                  {
                    offset: 1,
                    color: hexToRgba(color[1], 0.1)
                  }
                ],
                false
              ),
              shadowColor: hexToRgba(color[1], 0.1),
              shadowBlur: 10
            }
          },
          data: yAxisData2
        },
        {
          name: '女',
          type: 'line',
          smooth: true,
          symbolSize: 8,
          zlevel: 3,
          itemStyle:{
            normal:{
              label : {
                show: true // 在折线拐点上显示数据
              }
            }
          },
          lineStyle: {
            normal: {
              color: color[2],
              shadowBlur: 3,
              shadowColor: hexToRgba(color[2], 0.5),
              shadowOffsetY: 8
            }
          },
          symbol: 'circle', //数据交叉点样式 (实心点)
          areaStyle: {
            normal: {
              color: this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: hexToRgba(color[2], 0.3)
                  },
                  {
                    offset: 1,
                    color: hexToRgba(color[2], 0.1)
                  }
                ],
                false
              ),
              shadowColor: hexToRgba(color[2], 0.1),
              shadowBlur: 10
            }
          },
          data: yAxisData3
        }
      ]
    }

    chart01.setOption(option, true)
  }
}
</script>

<style>
/* .echart01 {
    font-size: 10px;
    font-weight: 700;
    width: 300px;
} */
</style>
